import React from 'react'
import PropTypes, { number, string } from 'prop-types'

import DateField from 'components/formFields/dateField'

const IdentityDate = ({ name, fieldType, ...fieldProps }) => {
	const pageFieldsData = {
		info: '',
		type: 'text',
		label: 'Data de exp',
		list: name,
		optional: true,
		variable: {
			name: fieldType.toUpperCase(),
			type: 'string',
			doc_display_style: 'plain',
		},
	}

	return <DateField {...fieldProps} pageFieldsData={pageFieldsData} />
}

IdentityDate.propTypes = {
	name: PropTypes.oneOfType([number, string]),
	fieldType: string,
}

export default IdentityDate
